// this is an autogenerated file from DesignSystem/TimelineEvent/Appointment/Actions/Unscheduled/More/Content/AddAppointment/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TimelineEvent_Appointment_Actions_Unscheduled_More_Content_AddAppointment_Content(
  $patient_id: uuid!
  $treatment_id: uuid!
  $appointment_type_id: uuid!
  $location_id: uuid!
  $interval_to_next: Int!
  $previous_appointment_id: uuid
) {
  appointments_create_appointment(
    args: {
      _patient_id: $patient_id
      _treatment_id: $treatment_id
      _appointment_type_id: $appointment_type_id
      _location_id: $location_id
      _previous_appointment_id: $previous_appointment_id
      _interval_to_next: $interval_to_next
      _unplanned: false
    }
  ) {
    id
  }
}

`